<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-dialog v-model="showPopUp" width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="kbPurple"
        class="mr-2"
        dark
        v-bind="attrs"
        v-on="on">
        {{ $t('general.save') }}
      </v-btn>
    </template>
    <v-card color="kbLight">
      <v-toolbar class="kbPurple" dark flat>
        {{ $t('general.addANameToYourTemplate') }}
        <v-spacer></v-spacer>
        <v-btn icon @click="showPopUp = false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" class="pb-0 pt-6">
              <v-text-field color="kbDarkBlue"
                            background-color="kbWhite"
                            :label="$t('general.templateName')"
                            maxlength="30"
                            :rules="[rules.required]"
                            solo
                            v-model="title">
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="d-flex align-center justify-end">
        <v-btn
          color="kbPurple"
          class="mr-1"
          outlined
          small
          @click="showPopUp = false">
          {{ $t('general.cancel') }}
        </v-btn>

        <v-btn
           color="kbPurple"
           dark
           small
           @click="msg()">
          {{ $t('general.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from '@/libs/rules'
export default {
  data () {
    return {
      showPopUp: false,
      rules
    }
  },
  computed: {
    title: {
      get () {
        return this.$store.state.campaigns.templateName
      },
      set (value) {
        this.$store.commit('SET_TEMPLATE_NAME', value)
      }
    }
  },
  methods: {
    msg () {
      if (!this.$refs.form.validate()) return
      this.$emit('template-name')
      this.showPopUp = false
    }
  }

}
</script>
